<template>
  <div>
    <div id="core" v-show="showType == 1"></div>
    <div id="design" v-show="showType == 2" :style="`background: url(${'https://lvshuhualv.oss-cn-hangzhou.aliyuncs.com/' + effectImageHrss});background-size: 100% 100%;`"></div>
    <div class="bottom_bar">
      <div class="lv_flex">
        <div class="lv_flex_1" @click="reflash">刷新</div>
        <div class="lv_flex_1" @click="show = true">信息</div>
        <div
          v-if="$route.query.productExpandId"
          class="lv_flex_1 comment-entry"
          @click="openComments"
        >
          留言评论<span v-if="comments.length"> · {{ comments.length }}</span>
        </div>
      </div>
    </div>
    <div class="view-bar" @click="changeShowType">
      <template v-if="showType == 2">
        <img src="@/assets/design.png">
        <div>效果图</div>
      </template>
      <template v-if="showType == 1">
        <img src="@/assets/3D.png">
        <div>3D</div>
      </template>
    </div>
    <div class="scale-bar">
      <div class="mr-38" @click="changeScale(-25)">-</div>
      <div @click="changeScale(25)">+</div>
      <div class="percent">{{sliderValue}}%</div>
    </div>
    <van-popup v-model="show" position="bottom" round>
      <div class="share_pop">
        <van-field v-model="form.name" label="作品名称" readonly />
        <van-field v-model="form.userName" label="创作作者" readonly />
        <van-field
          v-if="form.flowers"
          v-model="form.flowers"
          label="使用花材"
          autosize
          readonly
          type="textarea"
        />
        <van-field
          v-if="form.container"
          v-model="form.container"
          label="使用器皿"
          readonly
        />
      </div>
    </van-popup>
    <van-popup v-model="commentShow" position="bottom" round>
      <div class="comment-panel">
        <div class="comment-header">
          <div>
            <div class="comment-title">留言评论</div>
            <div class="comment-subtitle">
              {{ comments.length ? `${comments.length} 条留言` : "分享你对作品的感受" }}
            </div>
          </div>
          <button class="comment-close" type="button" aria-label="关闭留言" @click="commentShow = false">
            <van-icon name="cross" />
          </button>
        </div>

        <div class="comment-list">
          <div v-if="!comments.length" class="comment-empty">
            <van-icon name="comment-o" />
            <div class="comment-empty__title">还没有留言</div>
            <div class="comment-empty__desc">来写下第一条评论吧</div>
          </div>
          <div v-for="item in comments" :key="item.id" class="comment-item">
            <div class="comment-avatar">我</div>
            <div class="comment-content">
              <div class="comment-meta">
                <span class="comment-author">我</span>
                <span class="comment-time">{{ formatCommentTime(item.createdAt) }}</span>
              </div>
              <div class="comment-text">{{ item.content }}</div>
            </div>
          </div>
        </div>

        <div class="comment-composer">
          <van-field
            ref="commentInput"
            v-model="commentDraft"
            class="comment-input"
            type="textarea"
            rows="2"
            autosize
            maxlength="200"
            show-word-limit
            placeholder="说说你对这个作品的看法…"
          />
          <van-button
            class="comment-submit"
            color="#6e9f21"
            round
            block
            :disabled="!canSubmitComment"
            @click="submitComment"
          >
            发布留言
          </van-button>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { Editor } from "../../../3D-editor/index";
import { login } from "@/plugins/utils.js";
import { Toast } from "vant";
const { getFlowerUseMaterials } = require("@/utils/artworkMaterials");
let editor;
export default {
  computed: {
    canSubmitComment() {
      return Boolean(this.commentDraft.trim());
    },
  },
  mounted() {
    login(() => {
      editor = new Editor({
        dom: "core",
        plat: "mobile",
        readOnly: true,
      });

      if (
        this.$store.state.routeParams.productId ||
        this.$route.query.productExpandId
      ) {
        this.getData(
          this.$store.state.routeParams.productId ||
            this.$route.query.productExpandId
        );
      }
    }, this);
  },
  methods: {
    openComments() {
      this.commentShow = true;
      this.$nextTick(() => {
        const input = this.$refs.commentInput;
        if (input && input.focus) {
          input.focus();
        }
      });
    },
    submitComment() {
      const content = this.commentDraft.trim();
      if (!content) {
        Toast("请输入留言内容");
        return;
      }

      const comment = {
        id: `${Date.now()}-${Math.random().toString(16).slice(2)}`,
        content,
        createdAt: Date.now(),
      };
      this.comments = [comment, ...this.comments];
      this.commentDraft = "";
      this.saveComments();
      Toast.success("留言成功");
    },
    getCommentStorageKey(id = this.currentWorkId) {
      return id ? `lshl-work-comments:${id}` : "";
    },
    loadComments(id) {
      this.currentWorkId = String(id || "");
      const storageKey = this.getCommentStorageKey();
      if (!storageKey) return;

      try {
        const savedComments = JSON.parse(localStorage.getItem(storageKey) || "[]");
        this.comments = Array.isArray(savedComments)
          ? savedComments.filter((item) => item && item.content)
          : [];
      } catch (error) {
        this.comments = [];
      }
    },
    saveComments() {
      const storageKey = this.getCommentStorageKey();
      if (!storageKey) return;

      try {
        localStorage.setItem(storageKey, JSON.stringify(this.comments));
      } catch (error) {
        Toast("留言已显示，但当前环境无法保存");
      }
    },
    formatCommentTime(timestamp) {
      const time = Number(timestamp);
      if (!time) return "刚刚";

      const date = new Date(time);
      const now = new Date();
      const distance = now.getTime() - date.getTime();
      if (distance < 60 * 1000) return "刚刚";
      if (distance < 60 * 60 * 1000) return `${Math.floor(distance / 60000)} 分钟前`;

      const hour = String(date.getHours()).padStart(2, "0");
      const minute = String(date.getMinutes()).padStart(2, "0");
      if (date.toDateString() === now.toDateString()) return `今天 ${hour}:${minute}`;
      if (date.getFullYear() === now.getFullYear()) {
        return `${date.getMonth() + 1}月${date.getDate()}日 ${hour}:${minute}`;
      }
      return `${date.getFullYear()}年${date.getMonth() + 1}月${date.getDate()}日`;
    },
    changeShowType() {
      this.showType = this.showType == 1 ? 2 : 1;
    },
    changeScale(val){
      if (this.sliderValue + val === 0 || this.sliderValue + val === 225) {
        return;
      }
      this.sliderValue += val;
      if (this.showType == 1) {
        editor.setZoom(this.sliderValue / 100);
        return;
      } else {
        const designElement = document.getElementById('design');
        if (designElement) {
          designElement.style.transform = `scale(${this.sliderValue / 100})`;

        }
      }
      
    },
    reflash() {
      if (this.showType == 1) {
        editor.setAngle({
          x: this.lateralAxis,
          y: this.verticalAxis,
        });
      } else {
        const designElement = document.getElementById('design');
        if (designElement) {
          this.sliderValue = 100;
          designElement.style.transform = `scale(1)`;
        }
      }
    },
    getData(id) {
      this.loadComments(id);
      let url = "/product/getById";
      let params = {
        id,
        type: this.$route.query.type || 2,
      };
      if (this.$route.query.productExpandId) {
        url = "/product/expand/getById";
        params = {
          productExpandId: this.$route.query.productExpandId,
          type: this.$route.query.type || 2,
        };
      }

      this.$ajax
        .get(url, {
          params,
        })
        .then((res) => {
          document.title = res.data.name;
          let dataJson = JSON.parse(res.data.dataJson);
          this.lateralAxis = parseInt(dataJson.angle.x);
          this.verticalAxis = parseInt(dataJson.angle.y);
          const useMaterials = res.data.useMaterials || [];
          this.form = {
            name: res.data.name,
            userName: res.data.userName,
            flowers: getFlowerUseMaterials(useMaterials)
              .map((item) => {
                return `${item.materialName}（${item.count}朵）`;
              })
              .join("\n"),
            container: dataJson.objects.container
              ? dataJson.objects.container.resourceName
              : "",
          };
          this.effectImageHrss = res.data.effectImageHrss || '';
          editor.load(dataJson);
          this.reflash();
        });
    },
  },
  data() {
    return {
      sliderValue: 100,
      lateralAxis: 0,
      verticalAxis: 0,
      show: false,
      id: "",
      form: {
        name: "",
        userName: "",
        flowers: "",
        container: "",
      },
      currentWorkId: "",
      commentShow: false,
      commentDraft: "",
      comments: [],
      showType: 1,
      effectImageHrss: '',
    };
  },
};
</script>

<style lang="scss" scoped>

.mr-38{
  margin-right: rem(38);
}
#design {
  width: 100vw;
  height: 100vh;
  // background-size: 100% 100%;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  transform-origin: center center;
  transform: scale(1);
  transition: transform 0.3s ease;
  // overflow: hidden;
}
.view-bar{
  position: fixed;
  bottom: rem(200);
  left: rem(20);
  // width: rem(120);
  height: rem(67);
  padding: 0 rem(18);
  display: flex;
  justify-content: center;
  align-items: center;
  background: #FFFFFF;
  border: 1px solid #DCDCDC;
  border-radius: 2px;
  font-size: rem(28);
  font-weight: 100;
  img {
    width: rem(35);
    height: rem(35);
    padding-right: rem(17);
  }
}
.scale-bar{
  position: fixed;
  bottom: rem(116);
  left: rem(20);
  width: rem(240);
  height: rem(67);
  display: flex;
  align-items: center;
  background: #FFFFFF;
  border: 1px solid #DCDCDC;
  border-radius: 2px;
  font-size: rem(60);
  padding-left: rem(36);
  font-weight: 100;
}
.share_pop {
  padding: rem(30) 0;
}

.comment-panel {
  display: flex;
  flex-direction: column;
  height: 72vh;
  max-height: rem(980);
  min-height: rem(620);
  overflow: hidden;
  background: #f6f8f3;
}

.comment-header {
  display: flex;
  flex: none;
  align-items: center;
  justify-content: space-between;
  padding: rem(28) rem(30) rem(22);
  border-bottom: 1px solid #e8ece4;
  background: #fff;
}

.comment-title {
  color: #253329;
  font-size: rem(34);
  font-weight: 600;
  line-height: rem(46);
}

.comment-subtitle {
  margin-top: rem(4);
  color: #99a097;
  font-size: rem(22);
  line-height: rem(30);
}

.comment-close {
  display: flex;
  align-items: center;
  justify-content: center;
  width: rem(60);
  height: rem(60);
  padding: 0;
  border: 0;
  border-radius: 50%;
  background: #f1f3ef;
  color: #5c665d;
  font-size: rem(30);
}

.comment-list {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding: rem(8) rem(30) rem(20);
  -webkit-overflow-scrolling: touch;
}

.comment-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  min-height: rem(260);
  color: #bdc5b9;

  .van-icon {
    font-size: rem(76);
  }
}

.comment-empty__title {
  margin-top: rem(18);
  color: #697268;
  font-size: rem(28);
  line-height: rem(38);
}

.comment-empty__desc {
  margin-top: rem(6);
  font-size: rem(22);
  line-height: rem(30);
}

.comment-item {
  display: flex;
  padding: rem(24) 0;
  border-bottom: 1px solid #e8ece4;
}

.comment-avatar {
  display: flex;
  flex: none;
  align-items: center;
  justify-content: center;
  width: rem(64);
  height: rem(64);
  border-radius: 50%;
  background: #e5eed8;
  color: #628d20;
  font-size: rem(25);
  font-weight: 600;
}

.comment-content {
  flex: 1;
  min-width: 0;
  margin-left: rem(18);
}

.comment-meta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  line-height: rem(34);
}

.comment-author {
  color: #566254;
  font-size: rem(24);
  font-weight: 600;
}

.comment-time {
  color: #adb4aa;
  font-size: rem(20);
}

.comment-text {
  margin-top: rem(8);
  color: #2d352d;
  font-size: rem(27);
  line-height: rem(42);
  overflow-wrap: anywhere;
  white-space: pre-wrap;
}

.comment-composer {
  flex: none;
  padding: rem(18) rem(24) calc(#{rem(18)} + env(safe-area-inset-bottom));
  border-top: 1px solid #e8ece4;
  background: #fff;
}

.comment-input {
  overflow: hidden;
  box-sizing: border-box;
  border: 1px solid #dfe5da;
  border-radius: rem(16);
  background: #f8faf6;
}

.comment-submit {
  height: rem(72);
  margin-top: rem(16);
  font-size: rem(27);
  font-weight: 600;
}

::v-deep .comment-input .van-field__control {
  color: #2d352d;
  font-size: rem(26);
  line-height: rem(38);
}

::v-deep .comment-input .van-field__word-limit {
  color: #a7afa4;
  font-size: rem(20);
}

.percent{
  font-size: rem(26);
  margin-left: rem(33);
  padding-left: rem(21);
  border-left: 1px solid #979797;;
}

#core {
  width: 100vw;
  height: 100vh;
}
.bottom_bar {
  position: fixed;
  z-index: 10;
  bottom: 0;
  width: 100%;
  box-sizing: border-box;
}
.lv_flex {
  padding: rem(12) rem(20);
  > div {
    line-height: rem(80);
    text-align: center;
    background: #6e9f21;
    color: #fff;
    font-size: rem(28);

    border-radius: rem(6);
    + div {
      margin-left: rem(20);
    }
  }
}

.comment-entry {
  white-space: nowrap;
}
</style>
